import { useMutation } from "@tanstack/react-query";
import { requestURLs } from "../../Environment";
import {
  AxiosResponseAndError,
  ResponseType,
} from "@/api/types/axiosResponseType";
import ApiRequest from "../ApiRequest";


type AvailabilityApiResponseType = ResponseType<null>;

function useRemoveAvailabilityMutation() {
  const mutation = useMutation<
    AxiosResponseAndError<AvailabilityApiResponseType>["response"],
    AxiosResponseAndError<AvailabilityApiResponseType>["error"],
   string
  >({
    mutationFn: async (id:string) => {
      return ApiRequest.delete<AvailabilityApiResponseType>(
        `${requestURLs.availability}/${id}`,
      );
    },
  });

  return mutation;
}

export default useRemoveAvailabilityMutation;
